<ngx-datatable
  columnMode="force"
  ngClass="material"
  rowHeight="auto"
  (activate)="goToUser($event)"
  [footerHeight]="50"
  [headerHeight]="50"
  [limit]="8"
  [rowClass]="getRowClass"
  [rows]="users"
  [scrollbarH]="true"
  [scrollbarV]="false"
  [sorts]="[{ prop: 'createdAt', dir: 'desc' }]">
  <ngx-datatable-column name="Name" prop="firstName">
    <ng-template let-row="row" class="hover-pointer" ngx-datatable-cell-template>
      {{ userToString(row) }}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="E-mail" prop="email"></ngx-datatable-column>
  <ngx-datatable-column name="Phone" prop="phone">
    <ng-template let-row="row" class="hover-pointer" ngx-datatable-cell-template>
      <ion-row class="ion-align-items-center">
        <ion-text class="ion-margin-right">{{ row.phone }}</ion-text>
        @if (row.phone) {
          <ion-button
            (click)="copyPhoneNumberToClipboard(row); $event.stopPropagation()"
            size="small"
            fill="outline">
            <ion-icon name="clipboard-outline"></ion-icon>
          </ion-button>
        }
      </ion-row>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Creation" prop="createdAt">
    <ng-template let-row="row" ngx-datatable-cell-template>@if (tryParseDate(row.createdAt); as d) { {{ d | date }} } @else { - }</ng-template>
  </ngx-datatable-column>

  @if (showSubscription) {
    <ngx-datatable-column name="Subscription">
      <ng-template let-row="row" ngx-datatable-cell-template>
        @if (!row.subscriptionStatus) {
          <ion-chip color="medium">Not Found</ion-chip>
        }
        @if (row.subscriptionStatus === 'active') {
          <ion-chip color="success">Active</ion-chip>
        }
        @if (row.subscriptionStatus === 'paymentDue') {
          <ion-chip color="warning">Payment Due</ion-chip>
        }
        @if (row.subscriptionStatus === 'noSubscription') {
          <ion-chip color="danger">No Subscription</ion-chip>
        }
      </ng-template>
    </ngx-datatable-column>
  }

  @if (showRole) {
    <ngx-datatable-column name="Role">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text class="ion-margin-right">{{ capitalizeFirstLetter(row.role) }}</ion-text>
      </ng-template>
    </ngx-datatable-column>
  }
</ngx-datatable>
